const SliderImageSeparator = () => {

    return(
        <section className="slider-image-separator"></section>
    )

}

export default SliderImageSeparator